module.exports = "varying vec2 vUv;\r\n\r\nuniform float time;\r\n\r\nvoid main() \r\n{\r\n    float vLines = step(fract((vUv.y + time * .15) * 10.0), time * .25);\r\n    float hLines = step(fract((vUv.x * 1.5 + time * .15) * 10.0), (time - 4.0) * .3);\r\n\r\n    float lines = mix(vLines, hLines, step(4.0 - time, 0.0));\r\n    float value = clamp(lines, 0.0, .5);\r\n\tgl_FragColor = vec4(value, value, value, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/overlays/opening_overlay.frag.glsl
// module id = 45
// module chunks = 0